import TeamDetailView from './TeamDetailView';
import CreateTeam from './CreateTeam';
import TeamEdit from "./TeamEdit";

export default {
  list: TeamDetailView,
  create: CreateTeam,
  edit: TeamEdit
}
